export default {
  newDesign: true,
  title: "Çocuğunuz hangi profile daha yakın: mühendis, yaratıcı mı, yoksa mucit mi? | Kodland",
  downtimeUrl: "https://www.kodland.org/tr",
  parameters: {
    landing_id: "TrQTT",
    segment: 11,
  },
  startPage: {
    title:
      "Çocuğunuz hangi profile daha yakın: mühendis, yaratıcı mı, yoksa mucit mi?",
    subtitle:
      "Bazen bir çocuğun gerçekten tüm potansiyelini ortaya çıkarabilmesi için ihtiyacı olan tek şey, kendisine en uygun yolu bulmaktır.",
    image: {
      url: "/welcome/turkey_talent_pc.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/turkey_talent_mob.png",
      style: {
        width: "100%",
      },
    },
    button: "Hadi başlayalım",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Eğitim platformumuza güvendiğiniz için teşekkür ederiz!",
    subtitle:
      "Maalesef, tablet veya telefonlar derslerimizi kullanmak için uygun değildir. Bir sonraki derslerimizde sizi görmekten mutluluk duyacağız!",
  },
  quizRotateBySteps: {
    1: {
      question: "Çocuğunuz boş zamanlarında en çok ne yapmaktan hoşlanır?",
      answers: [
        "🔧 Bir şeyler inşa etmeyi, birleştirmeyi ya da nasıl çalıştıklarını keşfetmeyi sever",
        "🎀 Renk seçmeyi, görseller ve detaylarla ilgilenmeyi ya da bir şeyin nasıl görüneceğini düşünmeyi sever",
        "📝 Karakterler, hikâyeler, dünyalar ya da oyunların kendi versiyonlarını üretmeyi sever",
      ],
    },
    2: {
      question: "Çocuğunuz en çok hangi tür görevlerde başarılı olur?",
      answers: [
        "⚙️ Düşünmeyi, kuralları anlamayı, problem çözmeyi ya da örüntüleri fark etmeyi gerektiren görevlerde",
        "🖌️ Düzenlemeyi, sunmayı ya da bir şeyi daha anlaşılır ve güzel hâle getirmeyi gerektiren görevlerde",
        "🚀 Kendi fikirlerini ortaya koyabildiği ya da özgün bir şey üretebildiği görevlerde",
      ],
    },
    3: {
      question: "Çocuğunuz en çok hangi yönüyle övgü alır?",
      answers: [
        "🧩 Mantıklı düşünmesi, hızlı kavraması ve sorun çözebilmesiyle",
        "🖼️ Bir şeyleri düzenli, anlaşılır ve estetik hâle getirmesiyle",
        "🌟 Yaratıcılığı, hayal gücü ve özgün fikirleriyle",
      ],
    },
    4: {
      question: "Kimse hatırlatmadan kendi kendine ne yapar?",
      answers: [
        "🛠️ Bir şeyi anlamaya, çözmeye, düzeltmeye ya da geliştirmeye çalışır",
        "🎯 Bir şeyi daha iyi, daha anlaşılır ya da daha düzenli hâle gelene kadar gözden geçirir",
        "📖 Hikâyeler, karakterler, oyunlar ya da kendi dünyalarını kurgular",
      ],
    },
    5: {
      question: "Çocuğunuzu gerçekten en çok ne heyecanlandırır?",
      answers: [
        "🔬 Cevaplar bulmak ve bir şeylerin nasıl çalıştığını anlamak",
        "🎨 Güzel bir şey ortaya koymak ve bunu başkalarıyla paylaşmak",
        "🦋 Kendine ait bir şey üretmek: fikirler, karakterler ya da hikâyeler",
      ],
    },
    6: {
      question: "Aşağıdakilerden hangisi çocuğunuzu en iyi tanımlar?",
      answers: [
        "🧠 Bir şeylerin nasıl çalıştığını anlamayı sever, hataları fark eder ve sorular sorar",
        "✨ Bir şeyi tam istediği gibi olana kadar uzun süre geliştirebilir",
        "🌈 Yeni fikirler, hikâyeler ve yaratıcı çözümler üretmekte zorlanmaz",
      ],
    },
    7: {
      question: "Bir şey ilk denemede yolunda gitmediğinde ne yapar?",
      answers: [
        "🔍 Ne olduğunu anlamaya çalışır ve bir çözüm arar",
        "🔄 Aklındaki sonuca ulaşana kadar düzenlemeye devam eder",
        "💡 Başka bir yol dener ya da yeni bir fikir bulur",
      ],
    },
    8: {
      title: "Yolu yarıladık! Çocuğunuzun yaşını seçin, böylece ona göre bir sınıf oluşturabiliriz",
      subtitle: "Çocuğunuzun yaşına en uygun kursu seçeceğiz.",
      type: "age",
      button: "",
    },
    9: {
      title: "Sonuçlarınız hazır!",
      type: "one-page-contacts",
      subtitle: "Formu doldurun, sonuçlarınızı hemen göstereceğiz ve size özel ücretsiz bir ders planlayacağız.",
      button: "Neredeyse bitti 🔥",
    },
    10: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    11: {
      typeInfo: "noQuestions",
      title: "Mühendis! ⚙️",
      subtitle: "Çocuğunuz sadece kullanmıyor — nasıl çalıştığını anlamaya çalışıyor. Quiz sonucuna göre onda mühendis gibi düşünme eğilimi öne çıkıyor: bağlantıları fark ediyor, sistemlerin mantığını anlamak istiyor ve yeni teknolojileri hızlıca keşfedebiliyor.Ücretsiz deneme dersiniz zaten rezerve edildi 🎉 Canlı öğretmen derste çocuğunuzun teknik ve mantıksal becerilerini gözlemleyecek ve ona uygun ilk dijital projesini oluşturmasına yardımcı olacak.Ders sonrasında devam etmek isterseniz, TUGBACANER promosyon koduyla kursta %30 indirim kazanabilirsiniz.",
      button: "Teknik hazırlığı kontrol et",
      dynamicTypeInfo: [
        {
          condition: [{ step: "1", answer: "🔧 Bir şeyler inşa etmeyi, birleştirmeyi ya da nasıl çalıştıklarını keşfetmeyi sever" }],
          data: {
            typeInfo: "noQuestions",
            title: "Mühendis! ⚙️",
            subtitle: "Çocuğunuz sadece kullanmıyor — nasıl çalıştığını anlamaya çalışıyor. Quiz sonucuna göre onda mühendis gibi düşünme eğilimi öne çıkıyor: bağlantıları fark ediyor, sistemlerin mantığını anlamak istiyor ve yeni teknolojileri hızlıca keşfedebiliyor.Ücretsiz deneme dersiniz zaten rezerve edildi 🎉 Canlı öğretmen derste çocuğunuzun teknik ve mantıksal becerilerini gözlemleyecek ve ona uygun ilk dijital projesini oluşturmasına yardımcı olacak.Ders sonrasında devam etmek isterseniz, TUGBACANER promosyon koduyla kursta %30 indirim kazanabilirsiniz.",
            button: "Teknik hazırlığı kontrol et",
            imageLink: "/welcome/turkey_talent_v1.png",
          },
          
        },
        {
          condition: [{ step: "1", answer: "🎀 Renk seçmeyi, görseller ve detaylarla ilgilenmeyi ya da bir şeyin nasıl görüneceğini düşünmeyi sever" }],
          data: {
            typeInfo: "noQuestions",
            title: "Yaratıcı! 🎨",
            subtitle: "Çocuğunuz sadece güzel şeyler yapmıyor — fikrini görsel olarak anlatmaya çalışıyor. Quiz sonucuna göre onda yaratıcı ve tasarım odaklı düşünme eğilimi öne çıkıyor: renkleri, detayları, uyumu ve bir fikrin görsel olarak nasıl anlatılacağını hızlıca fark edebiliyor.Ücretsiz deneme dersiniz zaten rezerve edildi 🎉 Canlı öğretmen derste çocuğunuzun yaratıcılığını ve görsel düşünme becerilerini gözlemleyecek ve ona uygun ilk dijital projesini oluşturmasına yardımcı olacak.Ders sonrasında devam etmek isterseniz, TUGBACANER promosyon koduyla kursta %30 indirim kazanabilirsiniz.",
            button: "Teknik hazırlığı kontrol et",
            imageLink: "/welcome/turkey_talent_v2.png",
          },
        },
        {
          condition: [{ step: "1", answer: "📝 Karakterler, hikâyeler, dünyalar ya da oyunların kendi versiyonlarını üretmeyi sever" }],
          data: {
            typeInfo: "noQuestions",
            title: "Mucit! 💡",
            subtitle: "Çocuğunuz sadece oynamıyor — kendi kurallarını, hikâyelerini ve dünyalarını yaratıyor. Quiz sonucuna göre onda güçlü bir yaratıcı düşünme eğilimi var: kolayca hayal kuruyor, sıra dışı çözümler buluyor ve fikirlerini projeye dönüştürebiliyor.Ücretsiz deneme dersiniz zaten rezerve edildi 🎉 Canlı öğretmen derste çocuğunuzun doğal yeteneklerini ve ilgi alanlarını gözlemleyecek ve ona uygun ilk dijital projesini oluşturmasına yardımcı olacak.Ders sonrasında devam etmek isterseniz, TUGBACANER promosyon koduyla kursta %30 indirim kazanabilirsiniz.",
            button: "Teknik hazırlığı kontrol et",
            imageLink: "/welcome/turkey_talent_v3.png",
          },
        },
        {
          default: true,
          data: {
            typeInfo: "noQuestions",
            title: "Mühendis! ⚙️",
            subtitle: "Çocuğunuz sadece kullanmıyor — nasıl çalıştığını anlamaya çalışıyor. Quiz sonucuna göre onda mühendis gibi düşünme eğilimi öne çıkıyor: bağlantıları fark ediyor, sistemlerin mantığını anlamak istiyor ve yeni teknolojileri hızlıca keşfedebiliyor.Ücretsiz deneme dersiniz zaten rezerve edildi 🎉 Canlı öğretmen derste çocuğunuzun teknik ve mantıksal becerilerini gözlemleyecek ve ona uygun ilk dijital projesini oluşturmasına yardımcı olacak.Ders sonrasında devam etmek isterseniz, TUGBACANER promosyon koduyla kursta %30 indirim kazanabilirsiniz.",
            button: "Teknik hazırlığı kontrol et",
          },
        },
      ],
    },
    12: {
      title: "Kaydı tamamlamak için bu bilgileri inceleyin ✨",
      typeInfo: "pc-laptop",
      subtitle: "Derse katılmak için lütfen masaüstü veya dizüstü bilgisayar kullanın ve ders boyunca çocuğunuza eşlik etmeyi unutmayın. Deneme dersinin bireysel ve kişiye özel olduğunu hatırlatmak isteriz.",
      button: "Başka neler var?",
    },
    13: {
      title: "Deneme dersinizden önce e-posta ve WhatsApp üzerinden iletişimde kalacağız. 📞",
      typeInfo: "whatsapp",
      subtitle: "Dersinizden 24 saat önce bir hatırlatma göndereceğiz ve 2 saat öncesinde katılımınızı onaylamanızı isteyeceğiz. İletişim kurmamız, dersinizin planlandığı gibi gerçekleşmesi için önemlidir.",
      button: "Başka neler var?",
    },
    14: {
      title: "Ders platformumuzda gerçekleşecek 💻",
      typeInfo: "classroom",
      subtitle:
        "WhatsApp ve e-posta yoluyla bir bağlantı ve özel bir kod alacaksınız. Sadece bağlantıya tıklayın, doğrudan derse yönlendirileceksiniz. Ekstra uygulama veya indirme gerekmiyor.",
      button: "Anladım ✅",
    },
  },
};
